export default "https://cdn.questicon.mathletics.com/assets/audio/collectCoins-a1c5e82cc8c9d8f371cf8a158935ad00.mp3";